// Mirrors app/utils/siteHostnames.js on the API. The API is what actually
// decides which sites get monitored; this exists so the invoice and quote
// line editors can show staff, as they type, whether the remark they've
// written will be picked up by the outage tracker - rather than finding out
// days later that a site was never being watched.

const LABEL = '[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?';
const HOSTNAME_PATTERN = new RegExp('^(?:' + LABEL + '\\.)+[a-z]{2,24}$');
const BARE_LABEL = /^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?$/;

const PUBLIC_SUFFIXES = new Set([
  'co.uk', 'org.uk', 'me.uk', 'ltd.uk', 'plc.uk', 'net.uk', 'sch.uk', 'ac.uk', 'gov.uk', 'nhs.uk',
  'com.au', 'net.au', 'org.au', 'co.nz', 'co.za', 'com.br',
  'com', 'net', 'org', 'info', 'biz', 'uk', 'us', 'eu', 'io', 'dev', 'app', 'shop', 'online', 'site', 'xyz', 'co', 'cn'
]);

const DOMAIN_PRODUCT_TYPES = ['domain', 'domain renewal', 'domain transfer'];

export const isDomainProductType = (productType) =>
  DOMAIN_PRODUCT_TYPES.includes(String(productType || '').trim().toLowerCase());

export const extractHostname = (remark) => {
  if (!remark) return null;
  let value = String(remark).trim().toLowerCase();
  if (!value) return null;

  value = value.replace(/^https?:\/\//, '');
  value = value.split(/[/?#]/)[0];
  value = value.split('@').pop().split(':')[0].trim();
  value = value.replace(/^\.+/, '').replace(/[.,;:)\]]+$/, '');

  if (!value || value.length > 253) return null;
  if (!HOSTNAME_PATTERN.test(value)) return null;
  if (PUBLIC_SUFFIXES.has(value)) return null;
  return value;
};

export const tldFromProductName = (productName) => {
  const raw = String(productName || '').trim().toLowerCase();
  if (!raw.startsWith('.')) return null;
  const value = raw.replace(/^\.+/, '');
  if (!value || !/^[a-z]{2,24}(?:\.[a-z]{2,24})*$/.test(value)) return null;
  return value;
};

// What the outage tracker will watch for this line, or null if nothing.
export const hostnameFromLine = (line) => {
  if (!line) return null;
  const remarks = String(line.remarks || '').trim();

  const direct = extractHostname(remarks);
  if (direct) return direct;

  const embedded = remarks.split(/[\s,;]+/).map(extractHostname).find(Boolean);
  if (embedded) return embedded;

  if (!isDomainProductType(line.product_type)) return null;

  const tld = tldFromProductName(line.item_name || line.product_name);
  if (tld && BARE_LABEL.test(remarks.toLowerCase())) {
    const combined = extractHostname(remarks.toLowerCase() + '.' + tld);
    if (combined) return combined;
  }

  return extractHostname(line.item_name || line.product_name);
};
